import styled from 'styled-components'
import {
  Box,
} from '@usap/uicomponents'

const TABLET_LANDSCAPE = 'tablet-landscape'

const sharedContainerStyles = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ gap }) => gap || '16px'};
  border-radius: 0px;
`

export const StyledHelpBox = styled(Box)`
  flex-direction: column;
  justify-content: center;
  display: flex;
  gap: ${({ gap }) => gap || '16px'};
  border-radius: 0px;
  width: 100%;
`

export const StyledContactUsContainer = styled(sharedContainerStyles)`
  flex-direction: column;
  align-self: stretch;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    flex-direction: row;
    align-self: auto;
    gap: 48px;
  }
`

export const StyledQuestionContainer = styled(sharedContainerStyles)`
  align-self: stretch;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    gap: 16px;
    align-self: auto;
  }
`

export const StyledButtonContainer = styled(sharedContainerStyles)`
  align-self: stretch;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    align-self: auto;
  }
`

export const sharedTextStyles = styled.span`
  color: ${({ color }) => color || '#333'};
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: ${({ fontSize }) => fontSize || '14px'};
  font-weight: ${({ fontWeight }) => fontWeight || '500'};
  line-height: ${({ height }) => height || 'normal'};
  text-decoration-line: ${({ textDecoration }) => textDecoration || 'none'};
  text-align: center;
`

export const StyledQuestionText = styled(sharedTextStyles)`
  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    font-size: 20px;
    line-height: 30px;
  }
`

export const StyledButton = styled.button`
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: ${({ gap }) => gap || '8px'};
  border-radius: 4px;
  border: ${({ border }) => (border ? `${border} solid #3E3E47` : 'none')};
  background: ${({ color }) => color || '#FFF'};
  flex: 1 0 0;
  cursor: pointer;

  :hover {
    border:  ${({ border }) => (border ? `${border} solid #3E3E47` : 'none')};
    background: ${({ color }) => (color === '#FFCD05'
    ? 'rgb(255 220 80)'
    : color === '#282832'
      ? '#3a3a42'
      : 'rgb(255 243 192)')};
  }

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    padding: 0px 24px;
    flex: 0 1 auto;
  }
`

export const StyledButtonText = styled(sharedTextStyles)`
  font-weight: 600;
  line-height: 20px;
`

export const StyledLinks = styled.a`
  color: ${({ color }) => color || '#333'};
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
`

export const MaskedGroup = styled.div`
  position: relative;
  width: 40px;
  height: 40px;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    width: 48px;
    height: 48px;
  }
`

export const MaskedImage = styled.div`
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border-radius: 50%;
  object-fit: cover;
`
